import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "react-select";

import styles from "./Select.css";
import classnames from "classnames";
import Chevron from "../../Chevron";
// import "!style!css!react-select/dist/react-select.css";

function getValueFromProps (props) {
  if ("value" in props) {
    /*
    *  Destructure the value from the props
    */
    const { value } = props;

    return value;
  } else {
    /*
     *  Destructure value property of first item in the props.options
     *
     *  By providing a default "options" array in "defaultProps"
     *  it should always be available, so there's no need to test for it
     */
    const [ { value } = {} ] = props.options;

    return value;
  }
}

class TwSelect extends Component {
  static propTypes = {
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    compact: PropTypes.bool,
    valueRenderer: PropTypes.func,
    optionRenderer: PropTypes.func,
    positioningClassName: PropTypes.string,
    placeholder: PropTypes.string
  };

  static defaultProps = {
    options: [],
    onChange: () => {}
  }

  constructor (props) {
    super(props);
    this.state = {};

    if (!props.placeholder) {
      const value = getValueFromProps(props);

      this.state = {
        value
      };
    }
  }

  componentWillReceiveProps (props) {
    if (props.placeholder) {
      return;
    }

    const value = getValueFromProps(props);

    this.setState({ value });
  }

  handleChange = ({ value }) => {
    this.setState({ value });
    /*
     *  By providing a default "onChange" function in "defaultProps"
     *  it should always be available, so there's no need to test for it
     */
    this.props.onChange(value);
  }

  render () {
    const { options, compact = false, valueRenderer, optionRenderer, placeholder } = this.props;
    const { value } = this.state;
    const className = classnames({
      [styles.select]: true,
      [styles.compact]: compact
    }, this.props.positioningClassName);

    return (
      <div className={className}>
        <Select
          options={options}
          value={value}
          clearable={false}
          searchable={false}
          arrowRenderer={() => <Chevron small={true}/>}
          onChange={this.handleChange}
          optionRenderer={optionRenderer}
          valueRenderer={valueRenderer}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

export default TwSelect;
